// extracted by mini-css-extract-plugin
export var borderRadius = "_5f-4";
export var large = "_5f-3";
export var logoContainer = "_5f-0";
export var nameLogo = "_5f-2";
export var small = "_5f-1";